import  * as LogInActions from '../actions/LogInActions'

export interface ILoginState {
    result: LogInActions.ILogInType;
}

const initialLoginState : ILoginState = {
    result: {
        accessToken: null,
        errorType: null,
        errorMessage: null,
    }
}

export const logInReducer = (
    state: ILoginState = initialLoginState,
    action: any): ILoginState => {
    switch (action.type) {
        case LogInActions.LOG_IN_USER_COMPLETED_ACTION_TYPE:
            return {
                result: {
                    accessToken: action.json == null ? null : action.json.access_token,
                    errorType: action.errorType,
                    errorMessage: action.errorMessage,
                },
            }
        case LogInActions.LOG_OUT_USER_COMPLETED_ACTION_TYPE:
            return {
                result: {
                    accessToken: null,
                    errorType: null,
                    errorMessage: null,
                }
            }
        default:
            return state;
    }
}